import axios from "axios";
import Jsona from "jsona";
import Vue from "vue";

const state = {
  loading: false,
  guideSteps: [],
  stepSequence: [],
};

const dataFormatter = new Jsona();
const client = axios.create();
const STEP_NOT_FOUND_TEXT = "<span class=\"t-color-orange\">Detta steg gick inte att hitta</span>";

client.interceptors.request.use(
  function(config) {
    var token = window.localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }

    return config;
  }
);

client.interceptors.request.use(
  function(config) {
    state.loading = true;
    return config;
  }
);
client.interceptors.response.use(
  function(response) { 
    state.loading = false;
    return response;
  }, 
  function(error) {
    console.log(error); /* TODO: error handling? */
    state.loading = false;
  }
);

const getters = {
  loading: (state) => { return state.loading; },
  guideSteps: (state) => { return state.stepSequence; },
};

const actions = {
  fetchGuideSteps({commit}, {apiUrl, addToSequence}) {
    return new Promise((resolve) => {
      client
        .get(apiUrl + addToSequence[0])
        .then(response => {
          if (response && response.data) {
            let formattedResponse = dataFormatter.deserialize(response.data);
            commit("setGuideSteps", { guideSteps: formattedResponse, sequenceIds: addToSequence});
            resolve();
          }
        });
    });		
  },
  setSequence({commit}, sequenceIds) {
    commit("setSequence", sequenceIds);
  },
  addToSequence({commit}, {appendAfter, stepId}) {
    commit("addToSequence", {appendAfter, stepId});
  }
};

const mutations = {
  setGuideSteps(state, {guideSteps, sequenceIds}) {
    if(!guideSteps) return;
    Vue.set(state, "guideSteps", guideSteps);
    let sequence = sequenceIds.map(stepId => { 
      let step = guideSteps.find(step => step.id === stepId);
      if (step) return step;
      return { 
        id: stepId,
        text: STEP_NOT_FOUND_TEXT
      };
    });
    if (!sequence) return;
    Vue.set(state, "stepSequence", sequence);
  },
  addToSequence(state, {appendAfter, stepId}) {
    let appendAfterIndex = state.stepSequence.findIndex(step => step.id === appendAfter);
    if (appendAfterIndex >= 0) {
      state.stepSequence.splice(appendAfterIndex + 1);
    }
    let guideStep = state.guideSteps.find(step => step.id === stepId);
    if (!guideStep) {
      guideStep = { 
        id: stepId,
        text: STEP_NOT_FOUND_TEXT
      };
    }
    state.stepSequence.push(guideStep);
  }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
